import { ITirPmMenuLayoutStyleVars } from "./ITirPmMenuLayoutStyleVars";

export class TirPmMenuLayoutStyleVars implements ITirPmMenuLayoutStyleVars {
  "--tir-pm-menu-layout__bg-color" = "var(--bg-base, #FFF)";
  "--tir-pm-menu-layout__br" = "0.5rem";
  "--tir-pm-menu-layout__border" = "0.063rem solid var(--neutral-10, #EAEAEB)";
  "--tir-pm-menu-layout-button__ai" = "flex-start";
  "--tir-pm-menu-layout-button__text-fs" = "1rem";
  "--tir-pm-menu-layout-button__text-lh" = "1.5rem";
  "--tir-pm-menu-layout-button__text-fw" = "400";
  "--tir-pm-menu-layout-button__text-color" = "var(--text-primary, #272D37)";
  "--tir-pm-menu-layout-button__addition-size" = "1.5rem";
  "--tir-pm-menu-layout-button__addition-color" = "var(--text-primary, #272D37)";
  "--tir-pm-menu-layout-button__padding" = "0.75rem";
  "--tir-pm-menu-layout-button__gap" = "0.75rem";
  "--tir-pm-menu-layout-button__bg" = "transparent";
  "--tir-pm-menu-layout-button__bg-hover" =
    "var(--neutral-translucent-5, rgba(39, 45, 55, 0.05))";
  "--tir-pm-menu-layout-button__bg-active" =
    "var(--neutral-translucent-10, rgba(39, 45, 55, 0.10))";
  "--tir-pm-menu-layout-button__bg-selected" =
    "var(--neutral-translucent-10, rgba(39, 45, 55, 0.10))";

  static setVars(vars: TirPmMenuLayoutStyleVars) {
    const styleElement = document.createElement("style");
    let varsStr = "";
    Object.keys(vars).forEach((key) => {
      varsStr += `${key}: ${vars[key as keyof TirPmMenuLayoutStyleVars]};\n`;
    });
    styleElement.textContent = `
    :root {
      ${varsStr}
    }
  `;
    console.log(styleElement);
    document.head.appendChild(styleElement);
  }

  constructor(obj?: Partial<TirPmMenuLayoutStyleVars>) {
    if (obj) Object.assign(this, obj);
  }
}
